import { useState, useEffect } from 'react';
import { createModel } from 'hox';
import {

    ISCMSaleSoDescType,
    ISCMSaleSoFormFields,
    ISCMSaleSoGoodsDetail,
} from './scmSaleSoType';
import useGlobalModel from '@/model/globalModel';
import { ISCMDictDetail, ISCMDictSearch, saleRoService } from '../scmSaleRo/scmSaleRoService';
import useStorageState from '@/hooks/useStorageState';
import { useScmSaleRoDetailModel } from '../scmSaleRo/scmSaleRoModel'
const initSoDesc = {
    actualAmount: 0, //实际总价合计 （数量*单价）
    //对应展示字段
    numAll: 0, //开单
    giftsAll: 0,
    kindAll: 0, //种类
    stockOutAll: 0, //确认
    rejectAll: 0, //驳回
    amountAll: 0, //总计   （去除下浮，赠品的金额
};

export const useScmSaleSoDetailModel = createModel(function () {
    const {
        user: { shopId, shopName, userName },
    } = useGlobalModel();
    const { getTreeNodeName } = useScmSaleRoDetailModel()

    const initSoFormVal = {
        shopName,
        createUser: userName,
        operator: userName,
        saleCode: '', //销售单编码
        status: '', //销售单状态
        favorableAmount: '0', //整单优惠
        discountTotalAmount: '0.00', //优惠总额
        receivedAmount: '0.00', //已收金额
        totalAmount: '0.00', //应付金额
        discountRate: '0', //整单下浮
        saleTypeCode: '', //默认常规类型
        saleTypeName: '非直发', //默认常规类型
    } as ISCMSaleSoFormFields;

    // 供应链查看
    const [lookSoFormVal, setLookSoFormVal] = useState<ISCMSaleSoFormFields>(initSoFormVal);
    const [lookSoGoodsList, setLookSoGoodsList] = useState<ISCMSaleSoGoodsDetail[]>([]);
    const [lookSoDesc, setLookSoDesc] = useState<ISCMSaleSoDescType>(initSoDesc);


    useEffect(() => {
        let newDesc: ISCMSaleSoDescType = { ...initSoDesc };
        lookSoGoodsList.forEach((item) => {
            newDesc.numAll += Number(item.num);
            newDesc.giftsAll += Number(item.giftsNum);
            newDesc.stockInAll += Number(item.stockIoNum);
            newDesc.rejectAll += Number(item.rejectNum);
            newDesc.amountAll += Number(item.amount);
            newDesc.actualAmount += +item.num * +(item.price ?? 0);
            newDesc.giftsAmount += +Number(item.giftsNum) * +(item.price ?? 0);
        });
        newDesc.kindAll = new Set(lookSoGoodsList.map((item) => item.materialCode)).size ?? 0;
        setLookSoDesc(newDesc);
        // console.log(editGoodsList,newDesc)
    }, [lookSoGoodsList]);

    //获取一条数据
    const getSaleRoDetailOne = async (id: string, type?: string) => {
        let { retData } = await saleRoService.soOne(id);
        if (retData) {
            let { details, ...formVal } = retData;
            setLookSoGoodsList(() => details.map((item) => ({ ...item, key: item.id })));
            setLookSoFormVal({
                ...formVal,
                saleTypeName: getTreeNodeName(formVal.saleTypeCode),
                invoiceTypeName: getTreeNodeName(formVal.invoiceTypeCode),
                priceTypeName: getTreeNodeName(formVal.priceTypeCode),
                customerTypeName: getTreeNodeName(formVal.customerTypeCode),
                brandName: getTreeNodeName(formVal.brandCode),
                preferentialTypeName: getTreeNodeName(formVal.preferentialTypeCode as string)
            });
            // setIsCancel(retData.status === DictCodeEnmu.SALE_RETURN_STATUS_CANCEL ? true : false);  //判断是否已作废
            // setEditIsDirect(retData.purchaseTypeCode === DictCodeEnmu.PURCHASE_TYPE_DIRECT ? true : false);  //判断直发类型
        }
    };
    const resetLookCatch = () => {
        setLookSoFormVal(initSoFormVal)
        setLookSoGoodsList([])
    }

    return {
        lookSoFormVal,
        lookSoDesc,
        lookSoGoodsList,
        setLookSoGoodsList,
        getSaleRoDetailOne,
        resetLookCatch
    };
});
